export default __webpack_public_path__ + "static/imgSplash-6a86b32cc0b6b28fc10b4bad16d35d21.svg";